import api from '../api';
import jira from '../Util/jira';

import {bootstrapDangerGrowl} from '../../../Util/growler';

const customRegex = /^customfield_/;

export default {
    created() {
        const vm = this;

        api.getPriorities().then(
            (priorities) => {
                vm.priorities = priorities.sort((a,b) => {
                    return a.id > b.id;
                });
            },
            bootstrapDangerGrowl
        );

        //Annoyingly, there seems to be no other way to get available custom field options ><
        api.getMetadata('DPN').then(
            (metadata) => {
                const customFieldMappings = [
                    { jiraFieldName: 'customfield_11107', vmFieldName: 'requestedByOptions' },
                    { jiraFieldName: 'customfield_11108', vmFieldName: 'weights' }
                ];

                metadata.issuetypes.forEach(issueType => {
                    customFieldMappings.forEach(fieldMapping => {
                        //We only want to take the first set of allowedValues we encounter
                        if(!vm[fieldMapping.vmFieldName] && issueType.fields[fieldMapping.jiraFieldName]){
                            vm[fieldMapping.vmFieldName] = issueType.fields[fieldMapping.jiraFieldName].allowedValues;
                        }
                    });
                });
            },
            bootstrapDangerGrowl
        );
    },
    methods: {
        updateIssue() {
            const vm = this;
            const proms = [];

            if(vm.issueModel.status !== undefined) {
                const status = vm.issueModel.status !== null ? 
                vm.issueModel.status : 
                null;

                const id = status !== null ? status.id : null;
                const name = status !== null ? status.name : null;

                proms.push(api.postTransition(vm.issue.issueId, { Id:  id, Name: name }));
            }

            if(vm.issueModel.assignee !== undefined) {
                const accountId = vm.issueModel.assignee !== null ? 
                vm.issueModel.assignee.accountId : 
                null;
                
                proms.push(api.putAssignee(vm.issue.issueId, accountId));
            }

            const keys = Object.keys(vm.issueModel).filter(
                (key) => vm.issueModel[key] !== undefined 
            );

            let update = false;

            for(let i = 0 ; i < keys.length ; i++) {
                if(jira.fields[keys[i]]) {
                    update = true;
                    break;
                }
            }

            if(update) {
                proms.push(api.putIssue(vm.issue.issueId, jira.formUpdate(vm.issueModel)));
            }

            const finalize =  () => {
                vm.$refs.modal.hide();
                vm.issueModel = {};
                vm.transitions = null;
                vm.customFields = null;
            };

            Promise.all(proms).then(
                () => {
                    vm.$emit('update-issue', vm.issueModel );
                    finalize();
                },
                (error) => {
                    bootstrapDangerGrowl(error);
                    finalize();
                }
            );
        },
        getIssueMetaData(issue) {
            const vm = this;

            const getMetaData = new Promise((resolve, reject) => {
                    api.getIssueMeta(vm.issue.issueId).then(
                        (response) => {
                            const fields = [];
                            var keys = Object.keys(response.fields);
            
                            keys.forEach((key) => {
                                if(customRegex.exec(key)) {
                                    fields.push(response.fields[key]);
                                }
                            });

                            resolve(fields);
                        }, (error) => {
                            reject(error);
                        }
                    );
                });

            const getTransitions = new Promise((resolve, reject) => {
                    api.getTransitions(vm.issue.issueId).then(
                        (response) => {
                            resolve(response.transitions);
                        }, (error) => {
                            reject(error);
                        }
                    );
                });

            if(issue) {
                vm.issueModel.issueId = issue.issueId;

                Promise.all([getMetaData, getTransitions]).then(
                    (values) => {
                        vm.customFields = values[0];
                        vm.transitions = values[1];
                        vm.ready = true;
                    }, bootstrapDangerGrowl);
            }
        }
    },
    data() {
        return {
            priorities: null,
            weights: null,
            requestedByOptions: null,
            customFields: null,
            transitions: null
        };
    }
};